/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

import { isGraphQLError } from '@confluence/network';
import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql';

import type { useReverseTrialEligibleInstanceIsInReverseTrialQuery as useReverseTrialEligibleInstanceIsInReverseTrialQuery$data } from './__types__/useReverseTrialEligibleInstanceIsInReverseTrialQuery';

type HookType = {
	skip: boolean;
};

export const useReverseTrialEligible = ({ skip }: HookType = { skip: false }) => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	const skipQuery = skip || Boolean(process.env.REACT_SSR); // InstanceIsInReverseTrialQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
	const { data, loading, error } =
		useQuery<useReverseTrialEligibleInstanceIsInReverseTrialQuery$data>(
			gql`
				query useReverseTrialEligibleInstanceIsInReverseTrialQuery {
					signUpProperties {
						reverseTrial
					}
				}
			`,
			{
				skip: skipQuery,
			},
		);
	if (isGraphQLError(error) && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);
	}
	return {
		reverseTrialCohort: data?.signUpProperties?.reverseTrial,
		loading: skipQuery ? false : loading,
		error: skipQuery ? null : error,
	};
};
